import IdentityActions from 'actions/IdentityActions';
import {
  AA, Method, Functions, Resource,
} from 'sdk';

class IdentityActionCreator {
  claim(params) {
    AA.api(Functions.claimIdentity, Method.post, params).then((response) => {
      IdentityActions.claimSucceeded(response.data);
    }, (error) => {
      IdentityActions.claimFailed(error);
    });
  }

  fetch() {
    AA.api(Resource.identity, Method.get).then((response) => {
      IdentityActions.fetchSucceeded(response.data);
    }, (error) => {
      IdentityActions.fetchFailed(error);
    });
  }

  acknowledge(amazonAuthorId) {
    IdentityActions.acknowledged(amazonAuthorId);
  }

  confirm(params) {
    AA.api(Functions.confirmIdentity, Method.post, params).then((response) => {
      IdentityActions.confirmSucceeded(response.data);
    }, (error) => {
      IdentityActions.confirmFailed(error);
    });
  }
}

export default new IdentityActionCreator();
